"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "patient-availability" };
var _hoisted_2 = { class: "pa-header" };
var _hoisted_3 = { class: "pa-header-right" };
var _hoisted_4 = { class: "admin-badge" };
var _hoisted_5 = {
    key: 0,
    class: "patient-select-wrap"
};
var _hoisted_6 = { class: "locked-patient-name" };
var _hoisted_7 = {
    key: 1,
    class: "patient-select-wrap"
};
var _hoisted_8 = ["disabled"];
var _hoisted_9 = { value: "" };
var _hoisted_10 = ["value"];
var _hoisted_11 = {
    key: 0,
    class: "service-mode-tabs"
};
var _hoisted_12 = ["onClick"];
var _hoisted_13 = {
    key: 1,
    class: "pa-empty"
};
var _hoisted_14 = {
    key: 2,
    class: "pa-body"
};
var _hoisted_15 = { class: "panel blocks-panel" };
var _hoisted_16 = { class: "panel-header" };
var _hoisted_17 = {
    key: 0,
    class: "panel-loading"
};
var _hoisted_18 = {
    key: 1,
    class: "panel-empty"
};
var _hoisted_19 = { class: "block-card-top" };
var _hoisted_20 = { class: "block-time" };
var _hoisted_21 = {
    key: 0,
    class: "block-actions"
};
var _hoisted_22 = ["onClick"];
var _hoisted_23 = ["onClick"];
var _hoisted_24 = { class: "block-tags" };
var _hoisted_25 = { class: "tag context" };
var _hoisted_26 = { class: "tag recur" };
var _hoisted_27 = {
    key: 0,
    class: "block-notes"
};
var _hoisted_28 = { class: "panel preview-panel" };
var _hoisted_29 = {
    key: 0,
    class: "preview-available"
};
var _hoisted_30 = {
    key: 1,
    class: "preview-list"
};
var _hoisted_31 = { class: "preview-time" };
var _hoisted_32 = { class: "preview-ctx" };
var _hoisted_33 = {
    key: 0,
    class: "preview-note"
};
var _hoisted_34 = { class: "edit-modal" };
var _hoisted_35 = { class: "modal-header" };
var _hoisted_36 = { class: "modal-body" };
var _hoisted_37 = { class: "form-row" };
var _hoisted_38 = ["value"];
var _hoisted_39 = { class: "form-row two-col" };
var _hoisted_40 = { class: "form-row" };
var _hoisted_41 = { class: "excl-toggle" };
var _hoisted_42 = { class: "form-row" };
var _hoisted_43 = { class: "recur-options" };
var _hoisted_44 = { class: "radio-label" };
var _hoisted_45 = { class: "radio-label" };
var _hoisted_46 = { class: "radio-label" };
var _hoisted_47 = {
    key: 0,
    class: "form-row"
};
var _hoisted_48 = ["value"];
var _hoisted_49 = {
    key: 1,
    class: "form-row"
};
var _hoisted_50 = { class: "form-row" };
var _hoisted_51 = {
    key: 2,
    class: "form-error"
};
var _hoisted_52 = { class: "modal-footer" };
var _hoisted_53 = ["disabled"];
var _hoisted_54 = {
    key: 0,
    class: "glyphicon glyphicon-refresh spinning"
};
var _hoisted_55 = {
    key: 0,
    class: "pa-toast"
};
var vue_3 = require("vue");
var patientCardsStore_1 = require("../../../stores/patientCardsStore");
var VisitCompatibilityMatrix_vue_1 = require("./VisitCompatibilityMatrix.vue");
var patientAvailabilityService_1 = require("../../../services/patientAvailabilityService");
exports.default = (0, vue_1.defineComponent)({
    __name: 'PatientAvailability',
    props: {
        accountnumber: {},
        showMatrix: { type: Boolean },
        enableEnvironmentTabs: { type: Boolean },
        access: {}
    },
    setup: function (__props) {
        var _this = this;
        var props = __props;
        var access = (0, vue_3.computed)(function () { return props.access; });
        var store = (0, patientCardsStore_1.usePatientCardsStore)();
        // Use raw patients list — filteredPatients applies the Patients-page search/tag state
        // which is irrelevant here. Role-based scoping (admin = all, provider/nurse = assigned)
        // is handled server-side by GetPatientsFromStaffPatientsGroup via CheckAccountType.
        var patients = (0, vue_3.computed)(function () { return store.patients; });
        // Patient/family-in-chart: locked to a single patient, can add/edit blocks
        // only when the caller's access says so; admin/caregiver always can.
        var canEditBlocks = (0, vue_3.computed)(function () { var _a; return ((_a = props.access) === null || _a === void 0 ? void 0 : _a.kind) !== 'patient' || !!props.access.canAdd; });
        var loadingPatients = (0, vue_3.ref)(false);
        (0, vue_3.onMounted)(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (((_a = props.access) === null || _a === void 0 ? void 0 : _a.kind) === 'patient')
                            return [2 /*return*/];
                        if (!(store.patients.length === 0)) return [3 /*break*/, 2];
                        loadingPatients.value = true;
                        return [4 /*yield*/, store.loadPatientsFromStaffPatientsGroup()];
                    case 1:
                        _b.sent();
                        loadingPatients.value = false;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        /* ── Service mode ────────────────────────────────────────────────── */
        var SERVICE_MODES = [
            { value: 'in_home', label: 'In-Home', icon: 'bi-house-heart' },
            { value: 'inpatient', label: 'Inpatient', icon: 'bi-hospital' },
            { value: 'clinic', label: 'Clinic / Telehealth', icon: 'bi-camera-video' }
        ];
        var modeLabelMap = {
            in_home: 'In-Home', inpatient: 'Inpatient', clinic: 'Clinic / Telehealth'
        };
        var DAYS_OF_WEEK = [
            { value: 0, label: 'Sunday' }, { value: 1, label: 'Monday' }, { value: 2, label: 'Tuesday' },
            { value: 3, label: 'Wednesday' }, { value: 4, label: 'Thursday' }, { value: 5, label: 'Friday' },
            { value: 6, label: 'Saturday' }
        ];
        /* ── State ───────────────────────────────────────────────────────── */
        var selectedPatientId = (0, vue_3.ref)('');
        var serviceMode = (0, vue_3.ref)('in_home');
        var blocks = (0, vue_3.ref)([]);
        var loadingBlocks = (0, vue_3.ref)(false);
        var previewDate = (0, vue_3.ref)(new Date().toISOString().split('T')[0]);
        var toast = (0, vue_3.ref)('');
        // Lock selectedPatientId to the current chart's patient once access resolves
        // (it arrives async from the parent's useSchedulingAccess()).
        (0, vue_3.watch)(function () { return props.access; }, function (a) {
            if ((a === null || a === void 0 ? void 0 : a.kind) === 'patient')
                selectedPatientId.value = a.patientId;
        }, { immediate: true });
        function showToast(msg) {
            toast.value = msg;
            setTimeout(function () { return (toast.value = ''); }, 2600);
        }
        var contextOptions = (0, vue_3.computed)(function () { return patientAvailabilityService_1.CONTEXT_OPTIONS[serviceMode.value]; });
        var resolvedBlocks = (0, vue_3.computed)(function () {
            return (0, patientAvailabilityService_1.resolveBlocksForDate)(blocks.value, previewDate.value);
        });
        /* ── Load blocks when patient or mode changes ────────────────────── */
        function loadBlocks() {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!selectedPatientId.value) {
                                blocks.value = [];
                                return [2 /*return*/];
                            }
                            loadingBlocks.value = true;
                            _a = blocks;
                            return [4 /*yield*/, (0, patientAvailabilityService_1.getPatientBlocks)(props.accountnumber, selectedPatientId.value, serviceMode.value)];
                        case 1:
                            _a.value = _b.sent();
                            loadingBlocks.value = false;
                            return [2 /*return*/];
                    }
                });
            });
        }
        function switchMode(mode) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            serviceMode.value = mode;
                            return [4 /*yield*/, (0, patientAvailabilityService_1.setPatientServiceMode)(props.accountnumber, selectedPatientId.value, mode)];
                        case 1:
                            _a.sent();
                            loadBlocks();
                            return [2 /*return*/];
                    }
                });
            });
        }
        // immediate: true matters here — a patient/family-in-chart session arrives
        // with access already resolved (ManageScheduling.vue only mounts this
        // component once pageMode flips to 'patient', which itself only happens
        // after access resolves), so the watcher above already assigns
        // selectedPatientId SYNCHRONOUSLY during this component's own setup, before
        // this watcher would otherwise even be registered — without `immediate`,
        // that initial assignment is missed entirely and loadBlocks() never runs,
        // leaving the list permanently empty despite the patient having real blocks
        // (compare Master Calendar's single combined immediate watch, which doesn't
        // have this two-watcher ordering gap). Harmless no-op for staff/caregiver
        // sessions, where selectedPatientId starts '' until a later dropdown pick.
        (0, vue_3.watch)(selectedPatientId, function (pid) { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!pid) {
                            blocks.value = [];
                            return [2 /*return*/];
                        }
                        _a = serviceMode;
                        if (!props.enableEnvironmentTabs) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, patientAvailabilityService_1.getPatientServiceMode)(props.accountnumber, pid)];
                    case 1:
                        _b = _c.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _b = 'in_home';
                        _c.label = 3;
                    case 3:
                        _a.value = _b;
                        loadBlocks();
                        return [2 /*return*/];
                }
            });
        }); }, { immediate: true });
        /* ── Formatting ──────────────────────────────────────────────────── */
        function formatTime(time) {
            var _a = time.split(':').map(Number), h = _a[0], m = _a[1];
            var period = h >= 12 ? 'PM' : 'AM';
            var dh = h % 12 === 0 ? 12 : h % 12;
            return "".concat(dh, ":").concat(String(m).padStart(2, '0'), " ").concat(period);
        }
        function recurrenceLabel(block) {
            var _a, _b, _c;
            if (block.recurrence_type === 'daily')
                return 'Repeats daily';
            if (block.recurrence_type === 'weekly') {
                var day = (_b = (_a = DAYS_OF_WEEK.find(function (d) { return d.value === block.recurrence_day; })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '';
                return "Every ".concat(day);
            }
            return (_c = block.specific_date) !== null && _c !== void 0 ? _c : '';
        }
        /* ── Block modal ─────────────────────────────────────────────────── */
        var blockModalOpen = (0, vue_3.ref)(false);
        var savingBlock = (0, vue_3.ref)(false);
        var blockError = (0, vue_3.ref)('');
        var editingBlock = (0, vue_3.reactive)({
            id: undefined,
            contextLabel: '',
            startTime: '09:00',
            endTime: '10:00',
            exclusivity: 'soft',
            recurrenceType: 'daily',
            recurrenceDay: 1,
            specificDate: new Date().toISOString().split('T')[0],
            notes: ''
        });
        function openBlockModal(block) {
            var _a, _b, _c, _d;
            blockError.value = '';
            if (block) {
                editingBlock.id = block.id;
                editingBlock.contextLabel = block.context_label;
                editingBlock.startTime = block.start_time.slice(0, 5);
                editingBlock.endTime = block.end_time.slice(0, 5);
                editingBlock.exclusivity = block.exclusivity;
                editingBlock.recurrenceType = block.recurrence_type;
                editingBlock.recurrenceDay = (_a = block.recurrence_day) !== null && _a !== void 0 ? _a : 1;
                editingBlock.specificDate = (_b = block.specific_date) !== null && _b !== void 0 ? _b : new Date().toISOString().split('T')[0];
                editingBlock.notes = (_c = block.notes) !== null && _c !== void 0 ? _c : '';
            }
            else {
                editingBlock.id = undefined;
                editingBlock.contextLabel = (_d = contextOptions.value[0]) !== null && _d !== void 0 ? _d : '';
                editingBlock.startTime = '09:00';
                editingBlock.endTime = '10:00';
                editingBlock.exclusivity = 'soft';
                editingBlock.recurrenceType = 'daily';
                editingBlock.recurrenceDay = 1;
                editingBlock.specificDate = new Date().toISOString().split('T')[0];
                editingBlock.notes = '';
            }
            blockModalOpen.value = true;
        }
        function saveBlock() {
            return __awaiter(this, void 0, void 0, function () {
                var payload, res, idx, res;
                var _a, _b, _c, _d, _e, _f;
                return __generator(this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            if (editingBlock.endTime <= editingBlock.startTime) {
                                blockError.value = 'End time must be after start time.';
                                return [2 /*return*/];
                            }
                            savingBlock.value = true;
                            payload = {
                                contextLabel: editingBlock.contextLabel,
                                startTime: editingBlock.startTime,
                                endTime: editingBlock.endTime,
                                exclusivity: editingBlock.exclusivity,
                                recurrenceType: editingBlock.recurrenceType,
                                recurrenceDay: editingBlock.recurrenceType === 'weekly' ? editingBlock.recurrenceDay : null,
                                specificDate: editingBlock.recurrenceType === 'none' ? editingBlock.specificDate : null,
                                notes: editingBlock.notes || undefined
                            };
                            if (!editingBlock.id) return [3 /*break*/, 2];
                            return [4 /*yield*/, (0, patientAvailabilityService_1.updatePatientBlock)(props.accountnumber, editingBlock.id, payload)];
                        case 1:
                            res = _g.sent();
                            if (res.success) {
                                idx = blocks.value.findIndex(function (b) { return b.id === editingBlock.id; });
                                if (idx !== -1) {
                                    blocks.value[idx] = __assign(__assign({}, blocks.value[idx]), { context_label: payload.contextLabel, start_time: payload.startTime + ':00', end_time: payload.endTime + ':00', exclusivity: payload.exclusivity, recurrence_type: payload.recurrenceType, recurrence_day: (_a = payload.recurrenceDay) !== null && _a !== void 0 ? _a : null, specific_date: (_b = payload.specificDate) !== null && _b !== void 0 ? _b : null, notes: (_c = payload.notes) !== null && _c !== void 0 ? _c : null });
                                }
                                showToast('Block updated');
                            }
                            else {
                                showToast('Error updating block');
                            }
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, (0, patientAvailabilityService_1.addPatientBlock)(props.accountnumber, selectedPatientId.value, serviceMode.value, payload)];
                        case 3:
                            res = _g.sent();
                            if (res.success && res.id) {
                                blocks.value.push({
                                    id: res.id,
                                    accountnumber: props.accountnumber,
                                    patient_id: selectedPatientId.value,
                                    service_mode: serviceMode.value,
                                    context_label: payload.contextLabel,
                                    start_time: payload.startTime + ':00',
                                    end_time: payload.endTime + ':00',
                                    exclusivity: payload.exclusivity,
                                    recurrence_type: payload.recurrenceType,
                                    recurrence_day: (_d = payload.recurrenceDay) !== null && _d !== void 0 ? _d : null,
                                    specific_date: (_e = payload.specificDate) !== null && _e !== void 0 ? _e : null,
                                    notes: (_f = payload.notes) !== null && _f !== void 0 ? _f : null
                                });
                                showToast('Block added');
                            }
                            else {
                                showToast('Error saving block');
                            }
                            _g.label = 4;
                        case 4:
                            savingBlock.value = false;
                            blockModalOpen.value = false;
                            return [2 /*return*/];
                    }
                });
            });
        }
        function removeBlock(id) {
            return __awaiter(this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!confirm('Remove this unavailability block?'))
                                return [2 /*return*/];
                            return [4 /*yield*/, (0, patientAvailabilityService_1.deletePatientBlock)(props.accountnumber, id)];
                        case 1:
                            res = _a.sent();
                            if (res.success) {
                                blocks.value = blocks.value.filter(function (b) { return b.id !== id; });
                                showToast('Block removed');
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        return function (_ctx, _cache) {
            var _a, _b, _c;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    _cache[20] || (_cache[20] = (0, vue_2.createElementVNode)("div", { class: "pa-header-left" }, [
                        (0, vue_2.createElementVNode)("span", { class: "pa-avatar" }, [
                            (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-person-fill" })
                        ]),
                        (0, vue_2.createElementVNode)("div", null, [
                            (0, vue_2.createElementVNode)("h2", null, "Patient Availability"),
                            (0, vue_2.createElementVNode)("p", null, "Admin-managed unavailable blocks with context, used to plan parallel in-home visits")
                        ])
                    ], -1)),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("span", _hoisted_4, [
                            _cache[17] || (_cache[17] = (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-shield-lock-fill" }, null, -1)),
                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(((_a = access.value) === null || _a === void 0 ? void 0 : _a.kind) === 'admin' ? 'ADMINISTRATOR' : (((_b = access.value) === null || _b === void 0 ? void 0 : _b.kind) === 'caregiver' ? access.value.category.toUpperCase() : 'PATIENT')), 1)
                        ]),
                        (((_c = access.value) === null || _c === void 0 ? void 0 : _c.kind) === 'patient')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                                _cache[18] || (_cache[18] = (0, vue_2.createElementVNode)("label", { class: "select-label" }, "Patient", -1)),
                                (0, vue_2.createElementVNode)("span", _hoisted_6, [
                                    (0, vue_2.createElementVNode)("strong", null, (0, vue_2.toDisplayString)(access.value.patientName), 1)
                                ])
                            ]))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                                _cache[19] || (_cache[19] = (0, vue_2.createElementVNode)("label", { class: "select-label" }, "Patient", -1)),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((selectedPatientId).value = $event); }),
                                    class: "pa-select",
                                    disabled: loadingPatients.value
                                }, [
                                    (0, vue_2.createElementVNode)("option", _hoisted_9, (0, vue_2.toDisplayString)(loadingPatients.value ? 'Loading patients…' : '— Select a patient —'), 1),
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(patients.value, function (p) {
                                        var _a, _b;
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                            key: (_a = p.psersonalID) !== null && _a !== void 0 ? _a : p.id,
                                            value: (_b = p.psersonalID) !== null && _b !== void 0 ? _b : p.id
                                        }, (0, vue_2.toDisplayString)(p.firstName) + " " + (0, vue_2.toDisplayString)(p.lastName) + " — " + (0, vue_2.toDisplayString)(p.mrn), 9, _hoisted_10));
                                    }), 128))
                                ], 8, _hoisted_8), [
                                    [vue_2.vModelSelect, selectedPatientId.value]
                                ])
                            ]))
                    ])
                ]),
                (selectedPatientId.value && props.enableEnvironmentTabs)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, [
                        ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(SERVICE_MODES, function (m) {
                            return (0, vue_2.createElementVNode)("button", {
                                key: m.value,
                                class: (0, vue_2.normalizeClass)(['mode-tab', { active: serviceMode.value === m.value }]),
                                onClick: function ($event) { return (switchMode(m.value)); }
                            }, [
                                (0, vue_2.createElementVNode)("span", {
                                    class: (0, vue_2.normalizeClass)(["glyphicon", m.icon])
                                }, null, 2),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(m.label), 1)
                            ], 10, _hoisted_12);
                        }), 64))
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                (!selectedPatientId.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_13, __spreadArray([], (_cache[21] || (_cache[21] = [
                        (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-person-bounding-box pa-empty-icon" }, null, -1),
                        (0, vue_2.createElementVNode)("p", null, "Select a patient above to manage their availability blocks.", -1)
                    ])), true)))
                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_14, [
                        (0, vue_2.createElementVNode)("section", _hoisted_15, [
                            (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                _cache[23] || (_cache[23] = (0, vue_2.createElementVNode)("div", { class: "panel-title" }, [
                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-slash-circle" }),
                                    (0, vue_2.createElementVNode)("span", null, "Unavailable Blocks")
                                ], -1)),
                                (canEditBlocks.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                        key: 0,
                                        class: "btn-add",
                                        onClick: _cache[1] || (_cache[1] = function ($event) { return (openBlockModal()); })
                                    }, __spreadArray([], (_cache[22] || (_cache[22] = [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-plus" }, null, -1),
                                        (0, vue_2.createTextVNode)(" Add Block ", -1)
                                    ])), true)))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ]),
                            (loadingBlocks.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_17, __spreadArray([], (_cache[24] || (_cache[24] = [
                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-refresh spinning" }, null, -1),
                                    (0, vue_2.createTextVNode)(" Loading… ", -1)
                                ])), true)))
                                : (blocks.value.length === 0)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_18, " No blocks set for this patient in " + (0, vue_2.toDisplayString)(modeLabelMap[serviceMode.value]) + " mode. ", 1))
                                    : (0, vue_2.createCommentVNode)("", true),
                            (0, vue_2.createVNode)(vue_2.TransitionGroup, {
                                name: "block-fade",
                                tag: "div",
                                class: "blocks-list"
                            }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(blocks.value, function (block) {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                            key: block.id,
                                            class: (0, vue_2.normalizeClass)(["block-card", block.exclusivity])
                                        }, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_19, [
                                                (0, vue_2.createElementVNode)("span", _hoisted_20, (0, vue_2.toDisplayString)(formatTime(block.start_time)) + " – " + (0, vue_2.toDisplayString)(formatTime(block.end_time)), 1),
                                                (canEditBlocks.value)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_21, [
                                                        (0, vue_2.createElementVNode)("button", {
                                                            class: "icon-btn",
                                                            onClick: function ($event) { return (openBlockModal(block)); },
                                                            title: "Edit"
                                                        }, __spreadArray([], (_cache[25] || (_cache[25] = [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-pencil bi-pencil" }, null, -1)
                                                        ])), true), 8, _hoisted_22),
                                                        (0, vue_2.createElementVNode)("button", {
                                                            class: "icon-btn danger",
                                                            onClick: function ($event) { return (removeBlock(block.id)); },
                                                            title: "Delete"
                                                        }, __spreadArray([], (_cache[26] || (_cache[26] = [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-trash bi-trash" }, null, -1)
                                                        ])), true), 8, _hoisted_23)
                                                    ]))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                                (0, vue_2.createElementVNode)("span", _hoisted_25, (0, vue_2.toDisplayString)(block.context_label), 1),
                                                (0, vue_2.createElementVNode)("span", _hoisted_26, (0, vue_2.toDisplayString)(recurrenceLabel(block)), 1),
                                                (0, vue_2.createElementVNode)("span", {
                                                    class: (0, vue_2.normalizeClass)(["tag excl", block.exclusivity])
                                                }, [
                                                    (0, vue_2.createElementVNode)("span", {
                                                        class: (0, vue_2.normalizeClass)(["glyphicon", block.exclusivity === 'hard' ? 'bi-x-circle' : 'bi-check-circle'])
                                                    }, null, 2),
                                                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(block.exclusivity === 'hard' ? 'Hard · exclusive' : 'Soft · parallel ok'), 1)
                                                ], 2)
                                            ]),
                                            (block.notes)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_27, (0, vue_2.toDisplayString)(block.notes), 1))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ], 2));
                                    }), 128))
                                ]; }, undefined, true),
                                _: 1
                            })
                        ]),
                        (0, vue_2.createElementVNode)("section", _hoisted_28, [
                            _cache[28] || (_cache[28] = (0, vue_2.createElementVNode)("div", { class: "panel-header" }, [
                                (0, vue_2.createElementVNode)("div", { class: "panel-title" }, [
                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-eye" }),
                                    (0, vue_2.createElementVNode)("span", null, "Availability Preview")
                                ])
                            ], -1)),
                            _cache[29] || (_cache[29] = (0, vue_2.createElementVNode)("p", { class: "preview-subtitle" }, "Resolves recurring + one-off blocks onto a date", -1)),
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                type: "date",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((previewDate).value = $event); }),
                                class: "preview-date-input"
                            }, null, 512), [
                                [vue_2.vModelText, previewDate.value]
                            ]),
                            (resolvedBlocks.value.length === 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_29, __spreadArray([], (_cache[27] || (_cache[27] = [
                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-check-circle-fill preview-available-icon" }, null, -1),
                                    (0, vue_2.createElementVNode)("div", null, [
                                        (0, vue_2.createElementVNode)("strong", null, "Available all day"),
                                        (0, vue_2.createElementVNode)("p", null, "No blocks on this date — patient is open for visits.")
                                    ], -1)
                                ])), true)))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_30, [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(resolvedBlocks.value, function (block) {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                            key: block.id,
                                            class: (0, vue_2.normalizeClass)(["preview-item", block.exclusivity])
                                        }, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_31, (0, vue_2.toDisplayString)(formatTime(block.start_time)) + " – " + (0, vue_2.toDisplayString)(formatTime(block.end_time)), 1),
                                            (0, vue_2.createElementVNode)("div", _hoisted_32, [
                                                (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(block.context_label), 1),
                                                (block.notes)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_33, "· " + (0, vue_2.toDisplayString)(block.notes), 1))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                            ]),
                                            (0, vue_2.createElementVNode)("span", {
                                                class: (0, vue_2.normalizeClass)(["preview-excl", block.exclusivity])
                                            }, (0, vue_2.toDisplayString)(block.exclusivity === 'hard' ? 'Hard · exclusive' : 'Parallel ok'), 3)
                                        ], 2));
                                    }), 128))
                                ])),
                            _cache[30] || (_cache[30] = (0, vue_2.createStaticVNode)("<div class=\"preview-legend\" data-v-6e059420><span class=\"legend-item hard\" data-v-6e059420><span class=\"legend-dot\" data-v-6e059420></span> Hard — patient absent, mutually exclusive </span><span class=\"legend-item soft\" data-v-6e059420><span class=\"legend-dot\" data-v-6e059420></span> Soft — at home, compatible parallel visits allowed </span></div>", 1))
                        ])
                    ])),
                (props.showMatrix !== false)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(VisitCompatibilityMatrix_vue_1.default, { key: 3 }))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "body" }, [
                    (0, vue_2.createVNode)(vue_2.Transition, { name: "modal" }, {
                        default: (0, vue_2.withCtx)(function () { return [
                            (blockModalOpen.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    key: 0,
                                    class: "modal-overlay",
                                    onClick: _cache[16] || (_cache[16] = (0, vue_2.withModifiers)(function ($event) { return (blockModalOpen.value = false); }, ["self"]))
                                }, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_34, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_35, [
                                            (0, vue_2.createElementVNode)("h3", null, (0, vue_2.toDisplayString)(editingBlock.id ? 'Edit Block' : 'Add Block'), 1),
                                            (0, vue_2.createElementVNode)("button", {
                                                class: "modal-close",
                                                onClick: _cache[3] || (_cache[3] = function ($event) { return (blockModalOpen.value = false); })
                                            }, __spreadArray([], (_cache[31] || (_cache[31] = [
                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove" }, null, -1)
                                            ])), true))
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_36, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_37, [
                                                _cache[32] || (_cache[32] = (0, vue_2.createElementVNode)("label", null, "Context", -1)),
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((editingBlock.contextLabel) = $event); }),
                                                    class: "pa-select"
                                                }, [
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(contextOptions.value, function (opt) {
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                            key: opt,
                                                            value: opt
                                                        }, (0, vue_2.toDisplayString)(opt), 9, _hoisted_38));
                                                    }), 128))
                                                ], 512), [
                                                    [vue_2.vModelSelect, editingBlock.contextLabel]
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_39, [
                                                (0, vue_2.createElementVNode)("div", null, [
                                                    _cache[33] || (_cache[33] = (0, vue_2.createElementVNode)("label", null, "Start Time", -1)),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        type: "time",
                                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((editingBlock.startTime) = $event); })
                                                    }, null, 512), [
                                                        [vue_2.vModelText, editingBlock.startTime]
                                                    ])
                                                ]),
                                                (0, vue_2.createElementVNode)("div", null, [
                                                    _cache[34] || (_cache[34] = (0, vue_2.createElementVNode)("label", null, "End Time", -1)),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        type: "time",
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((editingBlock.endTime) = $event); })
                                                    }, null, 512), [
                                                        [vue_2.vModelText, editingBlock.endTime]
                                                    ])
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_40, [
                                                _cache[37] || (_cache[37] = (0, vue_2.createElementVNode)("label", null, "Exclusivity", -1)),
                                                (0, vue_2.createElementVNode)("div", _hoisted_41, [
                                                    (0, vue_2.createElementVNode)("button", {
                                                        class: (0, vue_2.normalizeClass)(['excl-btn', { active: editingBlock.exclusivity === 'soft' }]),
                                                        onClick: _cache[7] || (_cache[7] = function ($event) { return (editingBlock.exclusivity = 'soft'); }),
                                                        type: "button"
                                                    }, __spreadArray([], (_cache[35] || (_cache[35] = [
                                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-check-circle" }, null, -1),
                                                        (0, vue_2.createTextVNode)(" Soft · parallel ok ", -1)
                                                    ])), true), 2),
                                                    (0, vue_2.createElementVNode)("button", {
                                                        class: (0, vue_2.normalizeClass)(['excl-btn hard', { active: editingBlock.exclusivity === 'hard' }]),
                                                        onClick: _cache[8] || (_cache[8] = function ($event) { return (editingBlock.exclusivity = 'hard'); }),
                                                        type: "button"
                                                    }, __spreadArray([], (_cache[36] || (_cache[36] = [
                                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-x-circle" }, null, -1),
                                                        (0, vue_2.createTextVNode)(" Hard · exclusive ", -1)
                                                    ])), true), 2)
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_42, [
                                                _cache[41] || (_cache[41] = (0, vue_2.createElementVNode)("label", null, "Recurrence", -1)),
                                                (0, vue_2.createElementVNode)("div", _hoisted_43, [
                                                    (0, vue_2.createElementVNode)("label", _hoisted_44, [
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "radio",
                                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) { return ((editingBlock.recurrenceType) = $event); }),
                                                            value: "daily"
                                                        }, null, 512), [
                                                            [vue_2.vModelRadio, editingBlock.recurrenceType]
                                                        ]),
                                                        _cache[38] || (_cache[38] = (0, vue_2.createTextVNode)(" Repeats daily ", -1))
                                                    ]),
                                                    (0, vue_2.createElementVNode)("label", _hoisted_45, [
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "radio",
                                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) { return ((editingBlock.recurrenceType) = $event); }),
                                                            value: "weekly"
                                                        }, null, 512), [
                                                            [vue_2.vModelRadio, editingBlock.recurrenceType]
                                                        ]),
                                                        _cache[39] || (_cache[39] = (0, vue_2.createTextVNode)(" Repeats weekly ", -1))
                                                    ]),
                                                    (0, vue_2.createElementVNode)("label", _hoisted_46, [
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "radio",
                                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) { return ((editingBlock.recurrenceType) = $event); }),
                                                            value: "none"
                                                        }, null, 512), [
                                                            [vue_2.vModelRadio, editingBlock.recurrenceType]
                                                        ]),
                                                        _cache[40] || (_cache[40] = (0, vue_2.createTextVNode)(" One-off date ", -1))
                                                    ])
                                                ])
                                            ]),
                                            (editingBlock.recurrenceType === 'weekly')
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_47, [
                                                    _cache[42] || (_cache[42] = (0, vue_2.createElementVNode)("label", null, "Day of Week", -1)),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) { return ((editingBlock.recurrenceDay) = $event); }),
                                                        class: "pa-select"
                                                    }, [
                                                        ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(DAYS_OF_WEEK, function (d) {
                                                            return (0, vue_2.createElementVNode)("option", {
                                                                key: d.value,
                                                                value: d.value
                                                            }, (0, vue_2.toDisplayString)(d.label), 9, _hoisted_48);
                                                        }), 64))
                                                    ], 512), [
                                                        [
                                                            vue_2.vModelSelect,
                                                            editingBlock.recurrenceDay,
                                                            void 0,
                                                            { number: true }
                                                        ]
                                                    ])
                                                ]))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (editingBlock.recurrenceType === 'none')
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_49, [
                                                    _cache[43] || (_cache[43] = (0, vue_2.createElementVNode)("label", null, "Date", -1)),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        type: "date",
                                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) { return ((editingBlock.specificDate) = $event); })
                                                    }, null, 512), [
                                                        [vue_2.vModelText, editingBlock.specificDate]
                                                    ])
                                                ]))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (0, vue_2.createElementVNode)("div", _hoisted_50, [
                                                _cache[44] || (_cache[44] = (0, vue_2.createElementVNode)("label", null, [
                                                    (0, vue_2.createTextVNode)("Notes "),
                                                    (0, vue_2.createElementVNode)("span", { class: "optional" }, "(optional)")
                                                ], -1)),
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) { return ((editingBlock.notes) = $event); }),
                                                    placeholder: "e.g. Lunch, Dialysis appt…"
                                                }, null, 512), [
                                                    [vue_2.vModelText, editingBlock.notes]
                                                ])
                                            ]),
                                            (blockError.value)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_51, (0, vue_2.toDisplayString)(blockError.value), 1))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_52, [
                                            (0, vue_2.createElementVNode)("button", {
                                                class: "btn-secondary",
                                                onClick: _cache[15] || (_cache[15] = function ($event) { return (blockModalOpen.value = false); })
                                            }, "Cancel"),
                                            (0, vue_2.createElementVNode)("button", {
                                                class: "btn-primary",
                                                disabled: savingBlock.value,
                                                onClick: saveBlock
                                            }, [
                                                (savingBlock.value)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_54))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(editingBlock.id ? 'Update' : 'Add Block'), 1)
                                            ], 8, _hoisted_53)
                                        ])
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]; }, undefined, true),
                        _: 1
                    })
                ])),
                (0, vue_2.createVNode)(vue_2.Transition, { name: "toast" }, {
                    default: (0, vue_2.withCtx)(function () { return [
                        (toast.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_55, [
                                _cache[45] || (_cache[45] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-ok-circle" }, null, -1)),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(toast.value), 1)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]; }, undefined, true),
                    _: 1
                })
            ]));
        };
    }
});
